import { red, grey, blue, yellow } from '@mui/material/colors';

export const theme = {
    palette: {
        contrastThreshold: 4.5,
        background: {
            default: '#f4f5fd',
        },
        tabHeader: {
            main: blue[100],
        },
        tabHeaderDisabled: {
            main: grey[300],
        },
        tabHeaderDeleted: {
            main: red[100],
        },
        hoverBackground: {
            main: '#e8f5e9',
        },
        inactiveRecord: {
            main: '#c0c0c0',
        },
        inactiveRecordBackground: {
            main: grey[200],
        },
        actionButtonOutlined: {
            main: blue[900],
        },
        changed: {
            main: yellow[50],
        },
    },
    components: {
        MuiTab: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        color: blue[800],
                    },
                },
            },
        },
    },
};
